"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlag = void 0;
const TgglProvider_1 = require("./TgglProvider");
const react_1 = require("react");
function useFlag(slug, defaultValue) {
    const { client, getLoading, getError, onChange, trackFlagEvaluation } = (0, TgglProvider_1.useTggl)();
    const ref = (0, react_1.useRef)({
        listeningToLoadingOrError: false,
        listeningToValue: false,
        active: client.isActive(slug),
        value: client.get(slug, defaultValue),
        loading: getLoading(),
        error: getError(),
    });
    const [value, setValue] = (0, react_1.useState)({
        active: ref.current.active,
        get value() {
            ref.current.listeningToValue = true;
            return ref.current.value;
        },
        get loading() {
            ref.current.listeningToLoadingOrError = true;
            return getLoading();
        },
        get error() {
            ref.current.listeningToLoadingOrError = true;
            return getError();
        },
    });
    (0, react_1.useEffect)(() => {
        if (!ref.current.loading && !ref.current.error) {
            trackFlagEvaluation(slug);
        }
    }, [slug, trackFlagEvaluation]);
    (0, react_1.useEffect)(() => {
        return onChange(() => {
            const oldValues = Object.assign({}, ref.current);
            ref.current.active = client.isActive(slug);
            ref.current.value = client.get(slug, defaultValue);
            ref.current.loading = getLoading();
            ref.current.error = getError();
            if ((oldValues.active !== ref.current.active ||
                (oldValues.value !== ref.current.value &&
                    ref.current.listeningToValue)) &&
                !ref.current.loading &&
                !ref.current.error) {
                trackFlagEvaluation(slug);
            }
            if (oldValues.active !== ref.current.active ||
                (JSON.stringify(oldValues.value) !==
                    JSON.stringify(ref.current.value) &&
                    ref.current.listeningToValue) ||
                (oldValues.loading !== ref.current.loading &&
                    ref.current.listeningToLoadingOrError) ||
                (oldValues.error !== ref.current.error &&
                    ref.current.listeningToLoadingOrError)) {
                setValue({
                    active: ref.current.active,
                    get value() {
                        ref.current.listeningToValue = true;
                        return ref.current.value;
                    },
                    get loading() {
                        ref.current.listeningToLoadingOrError = true;
                        return getLoading();
                    },
                    get error() {
                        ref.current.listeningToLoadingOrError = true;
                        return getError();
                    },
                });
            }
        });
    }, [
        client,
        defaultValue,
        getError,
        getLoading,
        onChange,
        slug,
        trackFlagEvaluation,
    ]);
    return value;
}
exports.useFlag = useFlag;
//# sourceMappingURL=useFlag.js.map